import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargingIntroductionModule } from '../introduction/introduction.module';
import { ChargingStationInputModule } from './input/input.module';
import { ChargingStationOutboundInfoModule } from './outbound/info/info.module';
import { ChargingStationOutboundFormModule } from './outbound/form/form.module';

@NgModule({
  imports: [
    CommonModule,
    ChargingIntroductionModule,
    ChargingStationInputModule,
    ChargingStationOutboundInfoModule,
    ChargingStationOutboundFormModule,
  ],
})
export class ChargingStationModule {}
